import React from 'react';
import { motion } from 'framer-motion';
const mockupUrl = 'https://cdn.magicpatterns.com/uploads/qdsNue1w4h1u3rbMAbrEF9/ChatGPT_Image_3_oct_2026,_03_33_06_p.m..png';
export function MockupReminder() {
  return <section className="w-full bg-white px-4 pb-4 pt-16 sm:px-6 sm:pt-24" data-id="element-115" data-mp="10a6opszqfwsk">
      <motion.figure initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 0.55,
      ease: 'easeOut'
    }} className="relative mx-auto w-full max-w-5xl" data-id="element-116" data-mp="151ohvuvikt2z">
        <div className="overflow-hidden rounded-[2rem] border border-ink/10 bg-cream shadow-xl" data-id="element-117" data-mp="1o0k86v494nbj">
          <img src={mockupUrl} alt="Copertina di MakerLab con un allegro robot di cartone e icone colorate di progetti STEM" className="aspect-[4/3] w-full object-contain" data-id="element-118" data-mp="3ktc9rbvo7vex" />
        </div>
        <div className="absolute left-4 top-4 rounded-full bg-white px-3.5 py-2 text-xs font-bold text-ink shadow-lg sm:-left-5 sm:top-7" data-id="element-119" data-mp="3vjlcoruijbtt">
          🤖 Costruisci veri robot
        </div>
        <div className="absolute bottom-4 right-4 rounded-full bg-white px-3.5 py-2 text-xs font-bold text-ink shadow-lg sm:-bottom-4 sm:-right-4" data-id="element-120" data-mp="3lryvmevhuij5">
          📦 Oltre 100 progetti
        </div>
        <figcaption className="sr-only" data-id="element-121" data-mp="icjkfabdq2wf">
          MakerLab: i bambini costruiscono insieme robot creativi con materiali semplici.
        </figcaption>
      </motion.figure>
    </section>;
}